(function (exports, doc) {
	"use strict";

	exports.utils = exports.utils || {};

	// Runs the fn until the condition is true or maxCalls has been reached
	exports.utils.waitForIt = function (fn, condition, interval, maxCalls, context) {

		interval = interval || 1000;
		context = context || this;
		maxCalls = maxCalls || Infinity;

		var calls = 0;

		function testCondition() {
			if (calls < maxCalls && condition()) {
				fn.call(context);
			}
			else if (calls < maxCalls) {
				setTimeout(testCondition, interval);
			}
			calls++;
		}

		testCondition();

	};

	// Capitalizes the first letter of a text
	exports.utils.capitalizeFirstLetter = function (text) {
		return text.substring(0, 1).toUpperCase() + text.substring(1).toLowerCase();
	};

	exports.utils.replaceString = function (text, find, replacement, ignoreCase) {

		ignoreCase = (typeof ignoreCase === "undefined") ? true : ignoreCase;

		var params = ignoreCase ? 'gi' : 'g';

		return text.replace(new RegExp(find, params), replacement);
	};

	// Prevents a method from being executed more than every miliseconds specified by delay
	exports.utils.throttle = function (fn, delay, ctx) {

		var lastTime = new Date().getTime();

		return function () {
			var now = new Date().getTime();

			ctx = ctx || this;

			if (now - lastTime > delay) {
				fn.call(ctx);
				lastTime = now;
			}
		};

    };

    //format string
    exports.utils.formatString = function () {
        var str = arguments[0];
        for (var i = 0; i < arguments.length; i++) {
            var reg = new RegExp("\\{" + i + "\\}", "gm");
            str = str.replace(reg, arguments[i + 1]);
        }
        return str;
    };


	// Prevents a method from being executed util miliseconds specified by delay have passed
	// since it was last called
	exports.utils.debounce = function (fn, delay, ctx) {

		var timeout;

		return function () {

			var args = arguments;

			ctx = ctx || this;

			if (timeout) {
				clearTimeout(timeout);
			}

			timeout = setTimeout(function () {
				fn.apply(ctx, args);
			}, delay);
		};
	};

})(jQuery, document);